/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import  Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import ReactHTMLParser from 'react-html-parser';
import {
    object,
} from 'prop-types';
import { Link } from 'react-router-dom';
import { useUIDSeed } from 'react-uid';

import Slider from 'react-slick';

import Data from './ViewData';

const styles = (theme) => ({
    container: {
        [theme?.breakpoints?.down('sm')]: {
            maxWidth: theme?.palette?.tiers?.container?.maxWidth?.downSmall,
            margin: '0 auto',
        },
        [theme?.breakpoints?.down('md')]: {
            maxWidth: theme?.palette?.tiers?.container?.maxWidth?.downMedium,
            margin: '0 auto',
        },
        [theme?.breakpoints?.up('md')]: {
            maxWidth: 1440,
            margin: '0 auto',
        },
        [theme?.breakpoints?.up('lg')]: {
            maxWidth: 980,
            margin: '10px auto',
        },
        '& a': {
            textDecoration: 'none',
        },
        '& img': {
            maxWidth: '100%',
            width: '100%',
            margin: '15px 0',
            textAlign: 'center',
        },

        fontFamily: 'Roboto Slab,sans-serif',
    },
    description: {
        fontSize: 18,
        fontWeight: 400,
        textAlign: 'center',
        lineHeight: '1.2',
        color: theme?.palette?.motherWhoDescColor,
        margin: '15px 0',
    },
    socialContainer: {
        textAlign: 'center',
    },
    socialBlock: {
        display: 'inline-block',
        '& img': {
            width: 'auto',
        },
    },
    purchaseDesc: {
        fontSize: 14,
        textAlign: 'left',
        fontWeight: 400,
        lineHeight: '20px',
        paddingLeft: 30,
        '& a': {
            display: 'block',
            color: theme?.palette?.motherWhoLinkColor,
        },
    },
    slider: {
        width: '90% !important',
        '& img': {
            margin: '0 auto',
        },
    },
    sliderContainer: {
        marginBottom: 10,
        position: 'relative',
        '& .slick-list': {
            overflow: 'hidden',
        },
        '& .slick-slide': {
            display: 'inline-block',
        },
        '& .slick-prev, & .slick-next': {
            transform: 'translate(0,-50%)',
            cursor: 'pointer',
            color: 'transparent',
            border: 'none',
            outline: 0,
            background: '0 0',
            fontSize: 0,
            lineHeight: 0,
            top: '50%',
            zIndex: 9999,
            width: 50,
            height: 50,
            position: 'absolute',
        },
        '& .slick-prev': {
            left: 0,
            '&:hover': {
                borderRadius: '50%',
                background: theme?.palette?.motherWhoArrowBg,
                opacity: '0.6',

            },
        },
        '& .slick-prev:before': {
            content: '"\u003C"',
            color: theme?.palette?.common?.black,
            fontSize: 20,
            opacity: '.75',
            fontWeight: 900,
        },
        '& .slick-next': {
            right: 33,
            '&:hover': {
                borderRadius: '50%',
                background: theme?.palette?.motherWhoArrowBg,
                opacity: '0.6',
            },
        },
        '& .slick-next:before': {
            content: '"\u003E"',
            color: theme?.palette?.common?.black,
            fontSize: 20,
            opacity: '.75',
            fontWeight: 900,
        },
    },
});
const socialSection = (data, classes) => data.map((list) => {
    const {
        title, image,
    } = list;
    const seed = useUIDSeed();
    return (
        <div className={classes.socialBlock} key={seed(list)}>
            <img src={image} alt={title} />
        </div>
    );
});
const MomsWhoWowSweepstakesPage = ({ classes }) => {
    const {
        bannerImage, subBannerImage, description,
        tulipBannerImage, rulesImage, socialImage,
        purchaseDesc, officialRulesLink, privacyLink, momsWhowWow,
    } = Data;
    const seed = useUIDSeed();
    return (
        <Grid container className={classes.container}>
            <Grid item xs={12}>
                <img src={bannerImage} alt="Sweepstakes Banner" />
            </Grid>
            <Grid item xs={12}>
                <img src={subBannerImage} alt="Celebration Banner" />
            </Grid>
            <Grid item xs={12}>
                <Typography className={classes.description}>{ReactHTMLParser(description)}</Typography>
            </Grid>
            <Grid item xs={12}>
                <img src={tulipBannerImage} alt="Tulip Banner" />
            </Grid>
            <Grid item xs={12}>
                <Link to="/"> <img src={rulesImage} alt="Rules Banner" /></Link>
            </Grid>
            <Grid item xs={12}>
                <img src={tulipBannerImage} alt="Tulip Experience Banner" />
            </Grid>
            <Grid className={classes.socialContainer} item xs={12}>
                {socialSection(socialImage, classes)}
            </Grid>
            <Grid item xs={12}>
                <Slider
                    dots={false}
                    infinite={false}
                    speed={500}
                    slidesToShow={3}
                    slidesToScroll={3}
                    arrows
                    className={`carousel-container ${classes.sliderContainer}`}
                >
                    {
                        momsWhowWow.map((list)  => (
                            <div key={seed(list)} className={classes.slider}> <img src={list.image} alt={list.title} /></div>
                        ))
                    }
                </Slider>
            </Grid>
            <Grid item xs={12}>
                <Typography className={classes.purchaseDesc}>{ReactHTMLParser(purchaseDesc)}
                    <a href={officialRulesLink}>Click here to view the Official Rules</a>
                    <Link to={privacyLink}>Click Here to view our Privacy Policy.</Link>
                </Typography>
            </Grid>
        </Grid>
    );
};

MomsWhoWowSweepstakesPage.propTypes = {
    classes: object.isRequired,
};

export default withStyles(styles)(MomsWhoWowSweepstakesPage);
